import axios from 'axios'

export const state = {
  documents: null,
  pagination: null,
}

export const getters = {
  documents: (state) => state.documents,
  documentsPagination: (state) => state.pagination,
}

export const mutations = {
  SET_DOCUMENTS(state, documents) {
    state.documents = documents
  },

  SET_PAGINATION(state, headers) {
    state.pagination = {
      currentPage: parseInt(headers['x-current-page']),
      nextPage: parseInt(headers['x-next-page']),
      prevPage: parseInt(headers['x-prev-page']),
      totalItems: parseInt(headers['x-total-items']),
      totalPages: parseInt(headers['x-total-pages']),
      perPage: parseInt(headers['x-per-page']),
    }
  },
}

export const actions = {
  fetchAllDocuments({ commit }, params) {
    return axios
      .get('/api/documents', {
        params,
      })
      .then((response) => {
        const documents = response.data
        commit('SET_DOCUMENTS', documents)
        commit('SET_PAGINATION', response.headers)
        return documents
      })
  },

  viewDocument(_, id) {
    return axios.get(`/api/documents/${id}`).then((response) => response.data)
  },

  createDocument(_, payload) {
    return axios.post('/api/documents', payload)
  },

  updateDocument(_, payload) {
    return axios.put(`/api/documents/${payload.id}`, payload)
  },

  deleteDocument(_, id) {
    return axios.delete(`/api/documents/${id}`)
  },
}
